// react
import React, { useEffect, useState, useRef } from "react";
// internal
import GetTrad from "./../../components/utils/GetTrad"
// style
import "./Menu.css"
// utils
import getTrad from "./../../utils/getTrad"

const Menu = (props) => {

    const [center, setCenter] = useState([])
    const [sections, setSections] = useState([])

	useEffect(() => {
		if(props.content){
            let sectionsTemp = []
			for(let s of props.content.sections){
                if(s.id !== "center"){
                    s.subs = []
                    if(props.menu === s.id){
                        s.active = true;
                    }else{
                        s.active = false;
                    }
                    sectionsTemp.push(s)
                }
			}

            let centerTemp = []
			for(let p of props.content.products){
                if(p.section === "center"){
                    centerTemp.push(p)
                }else{
                    for(let i=0; i<sectionsTemp.length; i++){
                        if(p.section === sectionsTemp[i].id){
                            sectionsTemp[i].subs.push(p)
                        }
                    }
                }
			}

            setCenter(centerTemp)
            setSections(sectionsTemp)
		}
	}, [props.content, props.popup, props.menu])

	return (
		<React.Fragment>
			<div
				className="menu"
                style={{
                    display: props.menuDisplay ? "block" : "none"
                }}
			>
                <div
                    className="menu-separator"
                    style={{
                        marginTop:"70px"
                    }}
                ></div>
                {center.map(c => (
                    <div
                        key={"menusbu_"+c.id}
                        className="menu-section menu-section-sub tsv5 uppercase"
                        onClick={() => props.togglePopup(c.id)}
                    >{c.name[props.lang]}</div>
                ))}
                <div className="menu-separator"></div>
                {sections.map(s => (
                    <div key={"section_"+s.id}>
                        <div
                            className={"menu-section uppercase tsv5 "+(s.hasOwnProperty("active") === true && s.active === true ? "menu-section-selected" : "")+""}
                            onClick={() => props.toggle(s.id)}
                        >{s.name[props.lang]}</div>
                        <div
                            className={"menu-section-subs "+(s.id !== props.menu ? "menu-section-subs-down" : "")+""}
                        >
                            {s.subs.map(ss => (
                                <div
                                    key={"ss_"+ss.id}
                                    className="menu-section menu-section-sub tsv5"
                                    onClick={() => props.togglePopup(ss.id)}
                                >{ss.name[props.lang]}</div>
                            ))}
                        </div>
                        <div className="menu-separator"></div>
                    </div>
                ))}
                <div className="menu-bottom">
                    <a
                        href={getTrad("legalnoticelink", props.lang)}
						target={"_blank"}
                        className="menu-bottom-subs menu-bottom-subs-hover tsv5"
                        onClick={() => console.log("link")}
                    ><GetTrad id="legalnotice" lang={props.lang} /></a>
                    <a
                        href={getTrad("contactuslink", props.lang)}
						target={"_blank"}
                        className="menu-bottom-subs menu-bottom-subs-hover tsv5"
                    ><GetTrad id="contactus" lang={props.lang} /></a>
                    <a
                        href={getTrad("menubottomveolia", props.lang)}
						target={"_blank"}
                        className="menu-bottom-subs menu-bottom-subs-hover tsv5"
                        style={{ marginBottom:"15px" }}
                    >Veolia.com</a>
                    <div className="menu-separator"></div>
                    <div
                        className="menu-bottom-subs tsv5"
                    ><GetTrad id="followus" lang={props.lang} />:
                        <a target={"_blank"} href={getTrad("socialtwitter", props.lang)} className="menu-social twitter"></a>
                        <a target={"_blank"} href={getTrad("socialinstagram", props.lang)} className="menu-social instagram"></a>
                        <a target={"_blank"} href={getTrad("sociallinkedin", props.lang)} className="menu-social linkedin"></a>
                        <a target={"_blank"} href={getTrad("socialyoutube", props.lang)} className="menu-social youtube"></a>
                    </div>
                </div>
			</div>
		</React.Fragment>
	)
}

export default Menu;